export async function getOrSetFeatureAssignment(featureName: string): Promise<string | null> {
  let assignment = getFeatureCookie(featureName);

  if (assignment) {
    return assignment;
  }

  try {
    const response = await fetch(`/signalman_sc/features/${featureName}.json`, {
      credentials: 'include'
    });
    const assignedArray = await response.json(); // ["test"] or ["control"]

    if (Array.isArray(assignedArray) && assignedArray.length > 0) {
      assignment = assignedArray[0]; // "control" or "test"

      document.cookie = `feature_${featureName}=${assignment}; path=/; domain=.customink.com; max-age=${60*60*24*365}`;

      return assignment;
    }

    console.error('Unexpected response format:', assignedArray);
    return null;
  } catch (error) {
    console.error(`Failed to fetch feature assignment:`, error);
    return null;
  }
}

function getFeatureCookie(featureName: string): string | null {
  const name = `feature_${featureName}=`;
  const decodedCookies = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookies.split(';');

  for (let cookie of cookiesArray) {
    cookie = cookie.trim();
    if (cookie.startsWith(name)) {
      return cookie.substring(name.length);
    }
  }
  return null;
}
